/** Platform services: sign-in providers, purchases, push, app update, managed devices (prefix svc.*). */
export const en = {
  'svc.oauth.failed': "We couldn't sign you in with {provider}. Please try again.",
  'svc.oauth.cancelled': 'Sign-in was cancelled.',
  'svc.oauth.emailRequired': '{provider} did not share an email address. Please sign in with your email instead.',
  'svc.oauth.unavailable': 'Sign-in is not available right now. Please use your email.',
  'svc.update.forceTitle': 'Time for an update',
  'svc.update.forceBody': 'This version of Sketchling is too old to keep drawing. Update the app to get the newest lessons and fixes. Your drawings are safe.',
  'svc.update.optionalTitle': 'A new version is ready',
  'svc.update.optionalBody': 'Update Sketchling for new drawings and smoother lessons.',
  'svc.update.now': 'Update now',
  'svc.update.reload': 'Reload',
  'svc.update.later': 'Not now',
  'svc.managed.title': 'This device is managed',
  'svc.managed.body': 'Sketchling is made for family devices. This one is managed by a school or an organisation, so the app is turned off here.',
  'svc.managed.help': 'Questions? Write to us',
  'svc.pending.title': 'Waiting for a grown-up',
  'svc.pending.body': 'We asked a parent to approve the {plan} plan. As soon as they say yes, everything unlocks here. Keep drawing in the meantime!',
  'svc.pending.check': 'Check again',
  'svc.pending.still': 'Still waiting for approval.',
  'svc.pending.approved': 'Approved! Have fun drawing.',
  'svc.pending.expired': 'The request ran out of time. You can ask again from the plans screen.',
  'svc.pending.declined': 'The request was not approved this time.',
  'svc.pending.chip': 'Waiting for approval',
  'svc.purchasesOff': 'Purchases are turned off on this device. Ask a grown-up to allow in-app purchases in the device settings.',
  'svc.billing.redirecting': 'Opening secure checkout…',
  'svc.billing.confirming': 'Confirming your plan…',
  'svc.billing.success': 'Your plan is active. Thank you!',
  'svc.billing.cancelled': 'Checkout was cancelled. No payment was made.',
  'svc.billing.pendingWebhook': 'Payment received. Your plan will appear in a moment.',
  'svc.cheat.section': 'Platform services (simulate)',
  'svc.cheat.managed': 'Managed (MDM) device',
  'svc.cheat.supervised': 'Supervised device',
  'svc.cheat.purchasesOff': 'Purchases turned off',
  'svc.cheat.askToBuy': 'Ask to Buy (purchases wait for a parent)',
  'svc.cheat.update': 'App update gate',
  'svc.cheat.updateNone': 'Off',
  'svc.cheat.updateOptional': 'Optional',
  'svc.cheat.updateForce': 'Forced',
  'svc.cheat.approve': 'Parent approves',
  'svc.cheat.decline': 'Parent declines',
  'svc.cheat.testPush': 'Send a test push',
  'svc.cheat.pushSent': 'Test push sent ({n})',
  'svc.cheat.noPending': 'No purchase is waiting',
  'svc.cheat.store': 'Store adapter: {name}',
};

export const vi: Record<keyof typeof en, string> = {
  'svc.oauth.failed': 'Không đăng nhập được bằng {provider}. Vui lòng thử lại.',
  'svc.oauth.cancelled': 'Đã huỷ đăng nhập.',
  'svc.oauth.emailRequired': '{provider} không chia sẻ địa chỉ email. Vui lòng đăng nhập bằng email.',
  'svc.oauth.unavailable': 'Hiện chưa đăng nhập được bằng cách này. Vui lòng dùng email.',
  'svc.update.forceTitle': 'Đến lúc cập nhật rồi',
  'svc.update.forceBody': 'Phiên bản Sketchling này đã cũ, không dùng tiếp được nữa. Cập nhật app để có bài vẽ mới nhất và các bản sửa lỗi. Tranh của con vẫn được giữ nguyên.',
  'svc.update.optionalTitle': 'Đã có phiên bản mới',
  'svc.update.optionalBody': 'Cập nhật Sketchling để có thêm tranh mới và bài học mượt hơn.',
  'svc.update.now': 'Cập nhật ngay',
  'svc.update.reload': 'Tải lại',
  'svc.update.later': 'Để sau',
  'svc.managed.title': 'Thiết bị này đang được quản lý',
  'svc.managed.body': 'Sketchling dành cho thiết bị của gia đình. Thiết bị này do trường học hoặc tổ chức quản lý nên app không chạy ở đây.',
  'svc.managed.help': 'Cần hỗ trợ? Viết cho chúng tôi',
  'svc.pending.title': 'Đang chờ người lớn',
  'svc.pending.body': 'Đã gửi yêu cầu duyệt gói {plan} cho bố mẹ. Khi bố mẹ đồng ý, mọi thứ sẽ mở khoá ngay tại đây. Trong lúc chờ, con cứ vẽ tiếp nhé!',
  'svc.pending.check': 'Kiểm tra lại',
  'svc.pending.still': 'Vẫn đang chờ duyệt.',
  'svc.pending.approved': 'Đã được duyệt! Vẽ vui nhé.',
  'svc.pending.expired': 'Yêu cầu đã hết hạn. Có thể gửi lại ở màn hình gói.',
  'svc.pending.declined': 'Lần này yêu cầu chưa được duyệt.',
  'svc.pending.chip': 'Đang chờ duyệt',
  'svc.purchasesOff': 'Thiết bị này đang tắt mua hàng. Nhờ người lớn bật mua hàng trong ứng dụng ở phần cài đặt của máy.',
  'svc.billing.redirecting': 'Đang mở trang thanh toán an toàn…',
  'svc.billing.confirming': 'Đang xác nhận gói của bạn…',
  'svc.billing.success': 'Gói của bạn đã được kích hoạt. Cảm ơn bạn!',
  'svc.billing.cancelled': 'Đã huỷ thanh toán. Bạn chưa bị trừ tiền.',
  'svc.billing.pendingWebhook': 'Đã nhận thanh toán. Gói sẽ hiện ra trong giây lát.',
  'svc.cheat.section': 'Dịch vụ nền tảng (giả lập)',
  'svc.cheat.managed': 'Thiết bị được quản lý (MDM)',
  'svc.cheat.supervised': 'Thiết bị được giám sát',
  'svc.cheat.purchasesOff': 'Tắt mua hàng',
  'svc.cheat.askToBuy': 'Hỏi mua (chờ bố mẹ duyệt)',
  'svc.cheat.update': 'Cổng cập nhật app',
  'svc.cheat.updateNone': 'Tắt',
  'svc.cheat.updateOptional': 'Tuỳ chọn',
  'svc.cheat.updateForce': 'Bắt buộc',
  'svc.cheat.approve': 'Bố mẹ đồng ý',
  'svc.cheat.decline': 'Bố mẹ từ chối',
  'svc.cheat.testPush': 'Gửi thông báo thử',
  'svc.cheat.pushSent': 'Đã gửi thông báo thử ({n})',
  'svc.cheat.noPending': 'Không có giao dịch nào đang chờ',
  'svc.cheat.store': 'Kho mua hàng: {name}',
};
